export const GLOBAL_OPTION = { id: null, name: 'Global' };
export const COMPANY_MODES = {
    MAIN_TABLE: 'MainTable',
    ADD: 'Add',
    EDIT: 'Edit',
    APPROVAL: 'Approval',
    DELETE: 'Delete',
    CONVERT: 'Convert',
    LOADING: 'Loading',
};

export const INITIAL_COMPANY_DATA = {
    // id: null,
    name: '',
    entityName: '',
    tenantID: '',
    initialDomain: '',
    defaultPlanID: '',
    defaultPlan: '',
    invoiceDetailLevel: 0,
    partnerID: '',
    partnerName: '',
    status: 0,
    isActive: true,
    lastPairTest: null,
    lastSuccessfulPair: null,
    o365Sync: true,
    trunkLocationID: '',
    defaultTrunkID: '',
    isTrial: false,
    trialEnd: null,
    trialHold: false,
    trialEndLocal: null,
    trialCallLimit: 0,
    reverseProvision: false,
    callCounter: 0,
    isDeleted: false,
    defaultRegionID: null,
    trunkPrefix: '',
    trackingName2: null,
    trackingOption2: null,
    maxAdminPermissionScope: 20,
    overrideMSOLDeletionLimit: false,
    // lastSuccessfulHealthCheck: null,
    msolUsername: '',
    pairAttempts: 0,
    maxPairAttempts: 12,
    companySyncRequest: false,
    tcapAppConsent: null,
    mfaEnforced: true,
    primaryAddressID: null,
    approved: false,
    selectiveSyncPolicy: 0,
    attribute1: null,
    attribute2: null,
    attribute3: null,
    serviceCountries: null,
    businessNumber: null,
    primaryContactName: null,
    primaryContactEmail: null,
    primaryContactPhone: null,
    accountsContactEmail: null,
    supportContactEmail: null,
    visibilityGroupID: null,
    visibilityGroupName: '',
    companyBillingSettings: null,
    dialPlans: null,
    voicePolicies: null,
    plans: [],
    regions: null,
    engineLocations: [],
    dataStorageLocationID: null,
};

export const FORM_FIELD_PATHS = {
    // Basic Company Fields
    NAME: 'name',
    ENTITY_NAME: 'entityName',
    TENANT_ID: 'tenantID',
    INITIAL_DOMAIN: 'initialDomain',
    DEFAULT_PLAN_ID: 'defaultPlanID',
    DEFAULT_PLAN: 'defaultPlan',
    DEFAULT_TRUNK_ID: 'defaultTrunkID', // Added
    TRUNK_LOCATION_ID: 'trunkLocationID', // Added
    INVOICE_DETAIL_LEVEL: 'invoiceDetailLevel',
    PARTNER_ID: 'partnerID',
    PARTNER_NAME: 'partnerName',
    STATUS: 'status',
    IS_ACTIVE: 'isActive',

    // Trial Fields
    IS_TRIAL: 'isTrial',
    TRIAL_END: 'trialEnd',
    TRIAL_HOLD: 'trialHold',
    TRIAL_END_LOCAL: 'trialEndLocal',
    TRIAL_CALL_LIMIT: 'trialCallLimit',

    // Sync and Technical Fields
    O365_SYNC: 'o365Sync',
    SELECTIVE_SYNC_POLICY: 'selectiveSyncPolicy',
    REVERSE_PROVISION: 'reverseProvision',
    COMPANY_SYNC_REQUEST: 'companySyncRequest',

    // Administrative Fields
    MSOL_USERNAME: 'msolUsername',
    MAX_PAIR_ATTEMPTS: 'maxPairAttempts',
    MFA_ENFORCED: 'mfaEnforced',
    OVERRIDE_MSOL_DELETION_LIMIT: 'overrideMSOLDeletionLimit',
    PRIMARY_ADDRESS_ID: 'primaryAddressID', // Added
    // Contact Fields
    BUSINESS_NUMBER: 'businessNumber',
    PRIMARY_CONTACT_NAME: 'primaryContactName',
    PRIMARY_CONTACT_EMAIL: 'primaryContactEmail',
    PRIMARY_CONTACT_PHONE: 'primaryContactPhone',
    ACCOUNTS_CONTACT_EMAIL: 'accountsContactEmail',
    SUPPORT_CONTACT_EMAIL: 'supportContactEmail',

    // Company Billing Fields
    BILLING_SETTINGS: 'companyBillingSettings',
    BILLING_DAY: 'companyBillingSettings.billingDay',
    BILL_TO: 'companyBillingSettings.billTo',
    PER_NUMBER_PLAN: 'companyBillingSettings.perNumberPlan',
    SURCHARGE: 'companyBillingSettings.surcharge',
    SURCHARGE_TYPE: 'companyBillingSettings.surchargeType',
    LEAD_IN_PRORATA: 'companyBillingSettings.leadInProrata',
    PROCESS_BILLING: 'companyBillingSettings.processBilling',
    OMIT_NUMBER_BLOCKS: 'companyBillingSettings.omitNumberBlocks',
    BILL_ONE_LINE: 'companyBillingSettings.billOneLine',
    BILL_SHOW_CDR: 'companyBillingSettings.billShowCDR',
    BILL_SHOW_USERS: 'companyBillingSettings.billShowUsers',
    BILL_SHOW_RGS: 'companyBillingSettings.billShowRGS',
    BILL_SHOW_COMPANY: 'companyBillingSettings.billShowCompany',
    BILL_SHOW_ZERO: 'companyBillingSettings.billShowZero',
    BILL_SHOW_TRUNK: 'companyBillingSettings.billShowTrunk',
    BILL_SHOW_NUMBER_BLOCK: 'companyBillingSettings.billShowNumberBlock',
    BILLING_NOTES: 'companyBillingSettings.billingNotes',
    TRACKING_NAME_2: 'companyBillingSettings.trackingName2',
    TRACKING_OPTION_2: 'companyBillingSettings.trackingOption2',
    MIN_USER_COUNT: 'companyBillingSettings.minBillableUsers',
    MIN_RESOURCE_ACCOUNT_COUNT:
        'companyBillingSettings.minBillableResourceAccounts',
    // Wholesaler Billing Fields
    WHOLESALER_BILLING_SETTINGS: 'wholesalerBillingSettings',
    WHOLESALER_BILLING_DAY: 'wholesalerBillingSettings.billingDay',
    WHOLESALER_BILL_TO: 'wholesalerBillingSettings.billTo',
    WHOLESALER_MIN_BILLABLE_USERS: 'wholesalerBillingSettings.minBillableUsers',
    WHOLESALER_MIN_RESOURCE_ACCOUNT_COUNT:
        'wholesalerBillingSettings.minBillableResourceAccounts',
    WHOLESALER_PER_NUMBER_PLAN: 'wholesalerBillingSettings.perNumberPlan',
    WHOLESALER_SURCHARGE: 'wholesalerBillingSettings.surcharge',
    WHOLESALER_SURCHARGE_TYPE: 'wholesalerBillingSettings.surchargeType',
    WHOLESALER_LEAD_IN_PRORATA: 'wholesalerBillingSettings.leadInProrata',
    WHOLESALER_PROCESS_BILLING: 'wholesalerBillingSettings.processBilling',
    WHOLESALER_OMIT_NUMBER_BLOCKS: 'wholesalerBillingSettings.omitNumberBlocks',
    WHOLESALER_BILL_ONE_LINE: 'wholesalerBillingSettings.billOneLine',
    WHOLESALER_BILL_SHOW_CDR: 'wholesalerBillingSettings.billShowCDR',
    WHOLESALER_BILL_SHOW_USERS: 'wholesalerBillingSettings.billShowUsers',
    WHOLESALER_BILL_SHOW_RGS: 'wholesalerBillingSettings.billShowRGS',
    WHOLESALER_BILL_SHOW_COMPANY: 'wholesalerBillingSettings.billShowCompany',
    WHOLESALER_BILL_SHOW_ZERO: 'wholesalerBillingSettings.billShowZero',
    WHOLESALER_BILL_SHOW_TRUNK: 'wholesalerBillingSettings.billShowTrunk',
    WHOLESALER_BILL_SHOW_NUMBER_BLOCK:
        'wholesalerBillingSettings.billShowNumberBlock',
    WHOLESALER_BILLING_NOTES: 'wholesalerBillingSettings.billingNotes',
    WHOLESALER_TRACKING_NAME_2: 'wholesalerBillingSettings.trackingName2',
    WHOLESALER_TRACKING_OPTION_2: 'wholesalerBillingSettings.trackingOption2',

    // Partner Billing Fields
    PARTNER_BILLING_SETTINGS: 'partnerBillingSettings',
    PARTNER_BILLING_DAY: 'partnerBillingSettings.billingDay',
    PARTNER_BILL_TO: 'partnerBillingSettings.billTo',
    PARTNER_MIN_BILLABLE_USERS: 'partnerBillingSettings.minBillableUsers',
    PARTNER_MIN_RESOURCE_ACCOUNT_COUNT:
        'partnerBillingSettings.minBillableResourceAccounts',
    PARTNER_PER_NUMBER_PLAN: 'partnerBillingSettings.perNumberPlan',
    PARTNER_SURCHARGE: 'partnerBillingSettings.surcharge',
    PARTNER_SURCHARGE_TYPE: 'partnerBillingSettings.surchargeType',
    PARTNER_LEAD_IN_PRORATA: 'partnerBillingSettings.leadInProrata',
    PARTNER_PROCESS_BILLING: 'partnerBillingSettings.processBilling',
    PARTNER_OMIT_NUMBER_BLOCKS: 'partnerBillingSettings.omitNumberBlocks',
    PARTNER_BILL_ONE_LINE: 'partnerBillingSettings.billOneLine',
    PARTNER_BILL_SHOW_CDR: 'partnerBillingSettings.billShowCDR',
    PARTNER_BILL_SHOW_USERS: 'partnerBillingSettings.billShowUsers',
    PARTNER_BILL_SHOW_RGS: 'partnerBillingSettings.billShowRGS',
    PARTNER_BILL_SHOW_COMPANY: 'partnerBillingSettings.billShowCompany',
    PARTNER_BILL_SHOW_ZERO: 'partnerBillingSettings.billShowZero',
    PARTNER_BILL_SHOW_TRUNK: 'partnerBillingSettings.billShowTrunk',
    PARTNER_BILL_SHOW_NUMBER_BLOCK:
        'partnerBillingSettings.billShowNumberBlock',
    PARTNER_BILLING_NOTES: 'partnerBillingSettings.billingNotes',
    PARTNER_TRACKING_NAME_2: 'partnerBillingSettings.trackingName2',
    PARTNER_TRACKING_OPTION_2: 'partnerBillingSettings.trackingOption2',

    // Other Fields
    SERVICE_COUNTRIES: 'serviceCountries',
    REGIONS: 'regions',
    ENGINE_LOCATIONS: 'engineLocations',
    DATA_STORAGE_LOCATION_ID: 'dataStorageLocationID',
    PLANS: 'plans',
    VOICE_POLICIES: 'voicePolicies',
    DIAL_PLANS: 'dialPlans',
    VISIBILITY_GROUP_ID: 'visibilityGroupID',
    VISIBILITY_GROUP_NAME: 'visibilityGroupName',

    // Attributes
    ATTRIBUTE_1: 'attribute1',
    ATTRIBUTE_2: 'attribute2',
    ATTRIBUTE_3: 'attribute3',
};

export const BILLING_FIELD_PATHS_BY_MODE = {
    Company: {
        SETTINGS: FORM_FIELD_PATHS.BILLING_SETTINGS,
        BILLING_DAY: FORM_FIELD_PATHS.BILLING_DAY,
        BILL_TO: FORM_FIELD_PATHS.BILL_TO,
        PER_NUMBER_PLAN: FORM_FIELD_PATHS.PER_NUMBER_PLAN,
        SURCHARGE: FORM_FIELD_PATHS.SURCHARGE,
        SURCHARGE_TYPE: FORM_FIELD_PATHS.SURCHARGE_TYPE,
        LEAD_IN_PRORATA: FORM_FIELD_PATHS.LEAD_IN_PRORATA,
        PROCESS_BILLING: FORM_FIELD_PATHS.PROCESS_BILLING,
        OMIT_NUMBER_BLOCKS: FORM_FIELD_PATHS.OMIT_NUMBER_BLOCKS,
        BILL_ONE_LINE: FORM_FIELD_PATHS.BILL_ONE_LINE,
        BILL_SHOW_CDR: FORM_FIELD_PATHS.BILL_SHOW_CDR,
        BILL_SHOW_USERS: FORM_FIELD_PATHS.BILL_SHOW_USERS,
        BILL_SHOW_RGS: FORM_FIELD_PATHS.BILL_SHOW_RGS,
        BILL_SHOW_COMPANY: FORM_FIELD_PATHS.BILL_SHOW_COMPANY,
        BILL_SHOW_ZERO: FORM_FIELD_PATHS.BILL_SHOW_ZERO,
        BILL_SHOW_TRUNK: FORM_FIELD_PATHS.BILL_SHOW_TRUNK,
        BILL_SHOW_NUMBER_BLOCK: FORM_FIELD_PATHS.BILL_SHOW_NUMBER_BLOCK,
        BILLING_NOTES: FORM_FIELD_PATHS.BILLING_NOTES,
        TRACKING_NAME_2: FORM_FIELD_PATHS.TRACKING_NAME_2,
        TRACKING_OPTION_2: FORM_FIELD_PATHS.TRACKING_OPTION_2,
        MIN_USER_COUNT: FORM_FIELD_PATHS.MIN_USER_COUNT,
        MIN_RESOURCE_ACCOUNT_COUNT: FORM_FIELD_PATHS.MIN_RESOURCE_ACCOUNT_COUNT,
    },
    Wholesaler: {
        SETTINGS: FORM_FIELD_PATHS.WHOLESALER_BILLING_SETTINGS,
        BILLING_DAY: FORM_FIELD_PATHS.WHOLESALER_BILLING_DAY,
        BILL_TO: FORM_FIELD_PATHS.WHOLESALER_BILL_TO,
        PER_NUMBER_PLAN: FORM_FIELD_PATHS.WHOLESALER_PER_NUMBER_PLAN,
        SURCHARGE: FORM_FIELD_PATHS.WHOLESALER_SURCHARGE,
        SURCHARGE_TYPE: FORM_FIELD_PATHS.WHOLESALER_SURCHARGE_TYPE,
        LEAD_IN_PRORATA: FORM_FIELD_PATHS.WHOLESALER_LEAD_IN_PRORATA,
        PROCESS_BILLING: FORM_FIELD_PATHS.WHOLESALER_PROCESS_BILLING,
        OMIT_NUMBER_BLOCKS: FORM_FIELD_PATHS.WHOLESALER_OMIT_NUMBER_BLOCKS,
        BILL_ONE_LINE: FORM_FIELD_PATHS.WHOLESALER_BILL_ONE_LINE,
        BILL_SHOW_CDR: FORM_FIELD_PATHS.WHOLESALER_BILL_SHOW_CDR,
        BILL_SHOW_USERS: FORM_FIELD_PATHS.WHOLESALER_BILL_SHOW_USERS,
        BILL_SHOW_RGS: FORM_FIELD_PATHS.WHOLESALER_BILL_SHOW_RGS,
        BILL_SHOW_COMPANY: FORM_FIELD_PATHS.WHOLESALER_BILL_SHOW_COMPANY,
        BILL_SHOW_ZERO: FORM_FIELD_PATHS.WHOLESALER_BILL_SHOW_ZERO,
        BILL_SHOW_TRUNK: FORM_FIELD_PATHS.WHOLESALER_BILL_SHOW_TRUNK,
        BILL_SHOW_NUMBER_BLOCK:
            FORM_FIELD_PATHS.WHOLESALER_BILL_SHOW_NUMBER_BLOCK,
        BILLING_NOTES: FORM_FIELD_PATHS.WHOLESALER_BILLING_NOTES,
        TRACKING_NAME_2: FORM_FIELD_PATHS.WHOLESALER_TRACKING_NAME_2,
        TRACKING_OPTION_2: FORM_FIELD_PATHS.WHOLESALER_TRACKING_OPTION_2,
        MIN_USER_COUNT: FORM_FIELD_PATHS.WHOLESALER_MIN_BILLABLE_USERS,
        MIN_RESOURCE_ACCOUNT_COUNT:
            FORM_FIELD_PATHS.WHOLESALER_MIN_RESOURCE_ACCOUNT_COUNT,
    },
    Partner: {
        SETTINGS: FORM_FIELD_PATHS.PARTNER_BILLING_SETTINGS,
        BILLING_DAY: FORM_FIELD_PATHS.PARTNER_BILLING_DAY,
        BILL_TO: FORM_FIELD_PATHS.PARTNER_BILL_TO,
        PER_NUMBER_PLAN: FORM_FIELD_PATHS.PARTNER_PER_NUMBER_PLAN,
        SURCHARGE: FORM_FIELD_PATHS.PARTNER_SURCHARGE,
        SURCHARGE_TYPE: FORM_FIELD_PATHS.PARTNER_SURCHARGE_TYPE,
        LEAD_IN_PRORATA: FORM_FIELD_PATHS.PARTNER_LEAD_IN_PRORATA,
        PROCESS_BILLING: FORM_FIELD_PATHS.PARTNER_PROCESS_BILLING,
        OMIT_NUMBER_BLOCKS: FORM_FIELD_PATHS.PARTNER_OMIT_NUMBER_BLOCKS,
        BILL_ONE_LINE: FORM_FIELD_PATHS.PARTNER_BILL_ONE_LINE,
        BILL_SHOW_CDR: FORM_FIELD_PATHS.PARTNER_BILL_SHOW_CDR,
        BILL_SHOW_USERS: FORM_FIELD_PATHS.PARTNER_BILL_SHOW_USERS,
        BILL_SHOW_RGS: FORM_FIELD_PATHS.PARTNER_BILL_SHOW_RGS,
        BILL_SHOW_COMPANY: FORM_FIELD_PATHS.PARTNER_BILL_SHOW_COMPANY,
        BILL_SHOW_ZERO: FORM_FIELD_PATHS.PARTNER_BILL_SHOW_ZERO,
        BILL_SHOW_TRUNK: FORM_FIELD_PATHS.PARTNER_BILL_SHOW_TRUNK,
        BILL_SHOW_NUMBER_BLOCK: FORM_FIELD_PATHS.PARTNER_BILL_SHOW_NUMBER_BLOCK,
        BILLING_NOTES: FORM_FIELD_PATHS.PARTNER_BILLING_NOTES,
        TRACKING_NAME_2: FORM_FIELD_PATHS.PARTNER_TRACKING_NAME_2,
        TRACKING_OPTION_2: FORM_FIELD_PATHS.PARTNER_TRACKING_OPTION_2,
        MIN_USER_COUNT: FORM_FIELD_PATHS.PARTNER_MIN_BILLABLE_USERS,
        MIN_RESOURCE_ACCOUNT_COUNT:
            FORM_FIELD_PATHS.PARTNER_MIN_RESOURCE_ACCOUNT_COUNT,
    },
};

export const getBillingFieldPaths = (mode = 'Company') =>
    BILLING_FIELD_PATHS_BY_MODE[mode] || BILLING_FIELD_PATHS_BY_MODE.Company;

export const getBillingSettingsKey = (mode = 'Company') =>
    getBillingFieldPaths(mode).SETTINGS;

export const getBillingSettings = (formData, mode = 'Company') =>
    formData?.[getBillingSettingsKey(mode)] || {};

export { invoiceFormatList } from 'pages/organisations/sharedComponents/constants';
